module.exports = __webpack_public_path__ + "img/查看全部.fd1dae65.png";